export default __webpack_public_path__ + "static/img-7badefce083db5b02261461bc17811e3.jpg";